import { NULL_WHITE_LABEL_INTEGRATION } from 'shared/constants/smart-assistant';
import { WHITE_LABEL_DOMAIN_TROUBLESHOOTING_DOCS_URL } from 'shared/constants/white-label-constant';
import { WhiteLabelIntegration } from 'shared/interfaces/SmartAssistant';

export const isNullWhiteLabelIntegration = (whiteLabelIntegration: WhiteLabelIntegration) => {
  return JSON.stringify(whiteLabelIntegration) === JSON.stringify(NULL_WHITE_LABEL_INTEGRATION);
};

export const formatWhiteLabelDomainStatusMessage = (statusMessage: string) => {
  // We need to remove all [] because it contains amplify error codes (e.g. [AmplifyWaitTimeout])
  // All except for [] containing quotes since we want to keep [] containing records information
  const messageWithoutCodes = statusMessage.replace(/\[(?![^\]]*")[^\]]*\]/g, '');

  // We need to replace all urls with our documentation url
  const messageWithoutUrls = messageWithoutCodes.replace(
    /(https?:\/\/[^\s]+)/g,
    WHITE_LABEL_DOMAIN_TROUBLESHOOTING_DOCS_URL
  );

  return messageWithoutUrls;
};
